import React from 'react';

import Link from 'next/link';
import JobsCard from 'components/pages/jobs/jobslist/jobscard/JobsCard';
import useWindowSize from 'hooks/use-windowSize';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import classes from './RelatedCareerPathJob.module.scss';


const RelatedCareerPathJob = ({ jobs, toast }) => {
    const { mobileDevice, tabletDevice } = useWindowSize();
    return (
        <div>
            <Swiper
                slidesPerView={mobileDevice ? 0.9 : tabletDevice ? 2 : 3}
                spaceBetween={30}
                className="mySwiper">
                {jobs?.map((job) => (
                    <SwiperSlide key={job.id + job.type}>
                        <Link href={`/jobs?active_job=${job.id}`} >
                            <JobsCard
                                key={job.id}
                                jobData={job}
                                active={false}
                                toast={toast}
                            />
                        </Link>
                    </SwiperSlide>
                ))}
                {jobs && jobs.length > 0 && (
                    <SwiperSlide key="view-all">
                        <Link href="/jobs">
                            <div className={classes['view-all']}>View All Jobs</div>
                        </Link>
                    </SwiperSlide>
                )}
            </Swiper>

        </div>
    );
};

export default RelatedCareerPathJob;